<!-- Rendered inside the lot-details vb-dialog, which owns the title + close. -->
<div>
    <div class="d-flex justify-content-end align-content-center">
        <span class="offer-text-size offer-text-color"
            >Current Price:
            <strong class="text-primary"
                >${{ lot.currentPrice | number: "1.2-2" }}</strong
            ></span
        >
    </div>
    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--inline">
        <vb-spinner size="sm" label="Loading offer"></vb-spinner>
    </div>
    <div
        *ngIf="!isLoading && offerDetails && !offerDetails.isAdmin"
        class="mt-4 mb-4 px-4 mx-4">
        <p class="offer-text-size offer-text-color fw-semibold text-primary">
            Offer Details
        </p>
        <p>
            <span class="offer-text-size offer-text-color fw-semibold"
                >Quantity: </span
            ><span class="ms-4">{{ offerDetails.quantity }}</span>
        </p>
        <p>
            <span class="offer-text-size offer-text-color fw-semibold"
                >Price: </span
            ><span class="offer-text-size fw-semibold ms-4"
                >${{ offerDetails.price | number: "1.2-2" }}</span
            >
        </p>
        <p class="offer-text-size offer-text-color fw-semibold">
            Message for Seller
        </p>
        <p>
            {{ offerDetails.message }}
        </p>
    </div>
    <div
        *ngIf="
            (!isLoading && !offerDetails) ||
            (!isLoading && offerDetails && isCounterOffer) ||
            offerDetails?.status === offerStatus.Rejected
        "
        class="mt-4">
        <div *ngIf="isCounterOffer" class="mt-4 mb-4 px-4 mx-4">
            <p class="offer-text-size offer-text-color fw-semibold">
                Counter Offer From Seller
            </p>
            <p>
                <span>{{ offerDetails?.quantity }} at </span
                ><span class="offer-text-size fw-semibold"
                    >${{ offerDetails?.price | number: "1.2-2" }}</span
                >
            </p>
            <p class="offer-text-size offer-text-color fw-semibold">
                Message From Seller
            </p>
            <p>
                {{ offerDetails?.message }}
            </p>
        </div>
        <p
            *ngIf="isCounterOffer"
            class="text-primary fw-semibold offer-text-size">
            Make A Counter Offer
        </p>
        <div class="d-flex justify-content-between">
            <div class="align-content-center">
                <span
                    class="offer-text-size offer-text-color fw-semibold d-block pb-2">
                    Select Quantity:
                </span>
                <span
                    class="offer-text-size offer-text-color fw-semibold mt-4 pt-1 d-block">
                    Add A Custom Amount ($)
                </span>
            </div>
            <div class="align-content-center">
                <div class="d-flex justify-content-between align-items-center">
                    <button (click)="decrementQuantity()" class="mt-1">
                        <i class="fa-solid fa-circle-minus btn-quantity"></i>
                    </button>
                    <input
                        [disabled]="true"
                        type="number"
                        class="form-control w-50 text-center offer-inputs ps-18"
                        [(ngModel)]="quantity" />
                    <button (click)="incrementQuantity()" class="mt-1">
                        <i class="fa-solid fa-circle-plus btn-quantity"></i>
                    </button>
                </div>
                <input
                    type="number"
                    class="form-control w-100 mt-4 text-end offer-inputs"
                    inputmode="numeric"
                    pattern="\d*"
                    (keypress)="onKeyPress($event)"
                    (input)="onInputChange($event)"
                    [(ngModel)]="offerPrice" />
            </div>
        </div>
        <div class="mt-4">
            <span class="offer-text-size offer-text-color fw-semibold mt-1">
                Add An Optional Message For The Seller
            </span>
            <textarea
                type="text"
                class="form-control textarea-height"
                [maxlength]="maxLength"
                [(ngModel)]="offerMessage"></textarea>
            <div class="char-count">{{ characterCount }}/{{ maxLength }}</div>
        </div>
        <div
            class="d-flex justify-content-between pt-4 px-4 clear-both"
            *ngIf="isCounterOffer">
            <button
                (click)="toggleCounterOffer()"
                class="btn vb-info-btn py-2 px-4 w-50 fw-semibold button-text">
                Cancel
            </button>
            <button
                [disabled]="!offerPrice || offerPrice <= 0"
                (click)="placeCounterOffer(offerStatus.Pending)"
                class="btn vb-red-btn py-2 px-2 w-50 ms-4 fw-semibold button-text">
                Submit Counter Offer
            </button>
        </div>
        <div class="text-center mt-4" *ngIf="!isCounterOffer">
            <button
                [disabled]="!offerPrice || offerPrice <= 0"
                (click)="openConfirmationModal()"
                class="btn vb-red-btn py-2 px-4 fw-semibold button-text">
                Submit Offer
            </button>
        </div>
    </div>
    <div
        *ngIf="
            !isLoading &&
            offerDetails &&
            offerDetails.isAdmin &&
            !isCounterOffer &&
            offerDetails.status === offerStatus.Pending
        "
        class="mt-4">
        <div style="padding-inline: 20%">
            <p class="offer-text-size text-primary fw-semibold tp-offer-shape">
                Counter Offer From Seller
            </p>
            <div class="d-flex justify-content-between align-content-center">
                <span class="offer-text-size offer-text-color fw-semibold">
                    Quantity:
                </span>
                <span class="offer-text-size offer-text-color">{{
                    offerDetails.quantity
                }}</span>
            </div>
            <div
                class="d-flex justify-content-between align-content-center mt-4">
                <span class="offer-text-size offer-text-color fw-semibold">
                    Price:
                </span>
                <span class="offer-text-size offer-text-color"
                    >${{ offerDetails.price }}</span
                >
            </div>
            <div class="mt-4">
                <p class="offer-text-size offer-text-color fw-semibold mt-1">
                    Message From Seller
                </p>
                <p class="offer-text-size offer-text-color">
                    {{ offerDetails.message }}
                </p>
            </div>
        </div>
        <div
            style="margin-top: 15%"
            *ngIf="offerDetails.status === offerStatus.Pending">
            <div class="d-flex justify-content-around">
                <button
                    (click)="toggleCounterOffer()"
                    class="btn vb-info-btn py-2 px-4 fw-semibold button-text">
                    Counter Offer
                </button>
                <button
                    (click)="placeCounterOffer(offerStatus.Accepted)"
                    class="btn vb-red-btn py-2 px-4 fw-semibold button-text">
                    Accept Price
                </button>
            </div>
            <div class="text-center mt-4">
                <button
                    (click)="onRejectedClick(offerStatus.Rejected)"
                    class="btn py-2 px-4 fw-semibold btn-walk-away">
                    Walk Away
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template #dialogContent let-offer="offer">
    <div class="dialog-content mb-4">
        <div class="d-flex justify-content-between align-content-center">
            <span class="offer-text-size offer-text-color fw-semibold">
                Quantity:
            </span>
            <span class="fs-18 offer-text-color">{{ offer.quantity }}</span>
        </div>
        <div class="d-flex justify-content-between align-content-center mt-2">
            <span class="offer-text-size offer-text-color fw-semibold">
                Price:
            </span>
            <span class="fs-18 offer-text-color"
                >${{ offer.price | number: "1.2-2" }}</span
            >
        </div>
        <div class="mt-2">
            <p class="offer-text-size offer-text-color fw-semibold mt-1">
                Your Message To Seller
            </p>
            <p class="offer-text-size offer-text-color">
                {{ offer.message }}
            </p>
        </div>
    </div>
</ng-template>
